import Button from "@mui/material/Button";
import Grid2 from "@mui/material/Grid2";
import { CraftsFilter } from "./craftsFilter";
import { DownHoursFilter } from "./downHoursFilter";
import { SearchFilter } from "./SearchFilter";
import { TypesFilter } from "./typesFilter";
import { cmmsTheme } from "@setup/theme/cmms-theme";

export const Filters = () => {
	return (
		<>
			<Grid2 size={{ lg: 3, md: 12, xs: 12 }}>
				<SearchFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
				<CraftsFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
				<DownHoursFilter />
			</Grid2>
			<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
				<TypesFilter />
			</Grid2>
			<Grid2 size={{ lg: 1, md: 12, xs: 12 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					sx={{ height: cmmsTheme.dimensions.standardInput }}
					onClick={() => {
						const searchParams = new URLSearchParams(window.location.search);
						searchParams.delete("search");
						searchParams.delete("craft");
						searchParams.delete("type");
						searchParams.delete("downHours");
						window.history.replaceState(
							{},
							"",
							`${window.location.pathname}?${searchParams}`,
						);
						window.location.reload();
					}}
				>
					RESET
				</Button>
			</Grid2>
		</>
	);
};
